export default __webpack_public_path__ + "static/media/vision.6c57a4c5.svg";